import React from "react";
import { Container } from "react-bootstrap";
import { ContentWrapper, Sida } from "./ContentStyles";
import FAQ from "../pages/Faq";
import "./FaqPage.scss";
import { FaRegQuestionCircle } from "react-icons/fa";

const FaqPage = () => {
    return (
        <ContentWrapper className="faq-page">
            <div className="faq-page__bg" aria-hidden="true">
                <div className="faq-page__blob faq-page__blob--a" />
                <div className="faq-page__blob faq-page__blob--b" />
                <div className="faq-page__blob faq-page__blob--c" />
            </div>

            <Container>
                <Sida className="faq-page__layout">
                    <div className="faq-card">
                        {/* Liten pill/etikett */}
                        <div className="faq-pill">
                            <span className="faq-pill__icon"><FaRegQuestionCircle /></span>
                            <span className="faq-pill__text">FAQ</span>
                        </div>

                        {/* Er komponent */}
                        <FAQ />
                    </div>
                </Sida>
            </Container>
        </ContentWrapper>
    );
};

export default FaqPage;
